import { useSyncExternalStore } from 'react';

import { getFeedbackStorageKey } from './feedbackStorageKey';

export type FeedbackDirection = 'yes' | 'no';

function getStoredFeedbackDirection(petitionId: string): FeedbackDirection | false {
	try {
		const value = localStorage.getItem(getFeedbackStorageKey(petitionId));
		if (value === 'yes' || value === 'no') return value;
		// Backward compat: old entries stored 'true' before direction was tracked
		if (value === 'true') return 'yes';
		return false;
	} catch {
		return false;
	}
}

export function storeFeedback(petitionId: string, direction: FeedbackDirection): void {
	try {
		localStorage.setItem(getFeedbackStorageKey(petitionId), direction);
	} catch {
		// localStorage may be unavailable (private browsing, storage quota, etc.)
	}
}

const NOOP_SUBSCRIBE = () => () => {};

export function useStoredFeedbackDirection(petitionId: string): FeedbackDirection | false | null {
	return useSyncExternalStore(
		NOOP_SUBSCRIBE,
		() => getStoredFeedbackDirection(petitionId),
		() => null,
	);
}
